import { Component, Input, OnInit, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { LoanRequest } from 'src/model/loanRequest.model';
import { SharedLoanRequest } from 'src/model/sharedLoan.model';
import { AuthorizeLoanRequestComponent } from '../../LoanRequest/authorize-loan-request/authorize-loan-request.component';

@Component({
    selector: 'app-shared-loan-agreement',
    templateUrl: './shared-loan-agreement.component.html',
    styleUrls: ['./shared-loan-agreement.component.scss'],
    standalone: false
})
export class SharedLoanAgreementComponent implements OnInit {
  protected sharedService = inject(SharedService);
  private restapi = inject(RestApiService);
  private cosntructApi = inject(ConstructAPI);

  @Input() sharedLoanRequest: SharedLoanRequest;
  loggedInCompanyId: number;
  loggedInCompanyLoanRequest: LoanRequest;
  isAgreed = false;

  ngOnInit(): void {

    this.loggedInCompanyId = Number(sessionStorage.getItem("companyId"));
    this.loggedInCompanyLoanRequest = this.getLoggedInCompanyLoanRequest();
    this.isAgreed = this.checkIfLoggedInCompanyAgreed();
  }

  checkIfLoggedInCompanyAgreed() {
    const compIndex = this.sharedLoanRequest.Companies.findIndex(company => company.CompanyId == this.loggedInCompanyId);
    return this.sharedLoanRequest.Companies[compIndex].Agreed;
  }
  getLoggedInCompanyLoanRequest() {
    const index = this.sharedLoanRequest.LoanRequestsInfo.findIndex(request => request.CompanyId === this.loggedInCompanyId)
    return this.sharedLoanRequest.LoanRequestsInfo[index];

  }

  calculateSharedLoanTotal() {
    let sum = 0;

    for (let i = 0; i < this.sharedLoanRequest.LoanRequestsInfo.length; i++) {
      sum += this.sharedLoanRequest.LoanRequestsInfo[i].LoanInfo.Principal;
    }
    return sum;
  }

  findCompanyPrincipal(companyId: number) {
    const index = this.sharedLoanRequest.LoanRequestsInfo.findIndex(loan => loan.CompanyId == companyId);

    return this.sharedLoanRequest.LoanRequestsInfo[index].LoanInfo.Principal;

  }

  calculateSharedLoanTotalSettlement() {
    let sum = 0;

    for (let i = 0; i < this.sharedLoanRequest.LoanRequestsInfo.length; i++) {
      sum += this.sharedService.calculateEPFSettlementAmount(this.sharedLoanRequest.LoanRequestsInfo[i].LoanInfo.Principal, this.sharedLoanRequest.LoanRequestsInfo[i].LoanInfo.InterestRate, this.sharedLoanRequest.LoanRequestsInfo[i].LoanInfo.Term);
    }
    return sum;
  }

  processShareLoan(loanGroupId: number, action: string) {
    const data = {
      "remark": ""
    };

    const xhr = this.restapi.postRequest(this.cosntructApi.getSharedLoanProcess(loanGroupId, action), data);
    xhr.onreadystatechange = () => {

      if (xhr.readyState == 4) {
        if (xhr.readyState == 4) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openErrorMessage(xhr);
          }
        }
      }

    }
  }

  openAuthorizeLoanRequestModal() {
    const modalRef = this.sharedService.openModal(AuthorizeLoanRequestComponent, 'largeModal');
    modalRef.componentInstance.requestList = this.sharedLoanRequest.LoanRequestsInfo;
    modalRef.componentInstance.onlyViewLoan = true;

    // console.log(this.sharedLoanRequest.LoanRequestsInfo)
  }

}
